import { render } from "./DiagnosesPicker.vue?vue&type=template&id=12ea2e3d"
import script from "./DiagnosesPicker.vue?vue&type=script&lang=js"
export * from "./DiagnosesPicker.vue?vue&type=script&lang=js"

import "./DiagnosesPicker.vue?vue&type=style&index=0&id=12ea2e3d&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__